/**
 * The artifacts' plain vocabulary, with no zod and no API client: the `/artifacts` and `/draper` address validators
 * read it, and they ship in the entry chunk the sign-in page pays for (`scripts/check-bundle.mjs`). `artifacts.ts`
 * re-exports it.
 */
export const ARTIFACT_KINDS = ['brand_deal', 'deliverable', 'contract', 'negotiation'] as const;
export type ArtifactKind = (typeof ARTIFACT_KINDS)[number];

export const ARTIFACT_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
